module.exports = __webpack_public_path__ + "static/media/construction_sign.c9b38571.jpg";